var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-main-wrapper"},[_c('div',{staticClass:"login-main-container"},[_vm._t("login-col",[_c('div',[_vm._v("teste")])],{"classNameLogin":'login-col',"onLoginSubmit":_vm.onLoginSubmit,"onToggleOfficeButton":_vm.onToggleOfficeButton})],2)])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-045161de","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/office/js/components/wl-auth/index.vue
// module id = Brfp
// module chunks = 0